import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { pxToRem } from '../../../utils/pxToRem';
import { conventionContent } from '../content';
import { SectionInner } from '../components/SectionInner';
import { CornerFrame } from '../components/CornerFrame';

export function Venue() {
  const { venue } = conventionContent;
  return (
    <Box
      component='section'
      id={venue.sectionId}
      aria-labelledby={venue.headingId}
      sx={{
        backgroundColor: 'background.default',
        paddingBlock: { mobile: pxToRem(48), laptop: pxToRem(200) },
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <SectionInner
        direction={{ mobile: 'column', laptop: 'row' }}
        gap={{ mobile: pxToRem(48), laptop: pxToRem(32) }}
        sx={{ alignItems: 'center', justifyContent: 'center' }}
      >
        <Box
          sx={{
            position: 'relative',
            width: { mobile: pxToRem(300), laptop: pxToRem(256) },
            height: { mobile: pxToRem(137), laptop: pxToRem(264) },
            flexShrink: 0,
          }}
        >
          <Box
            aria-hidden
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '100%',
              height: '100%',
            }}
          >
            <CornerFrame
              corner='bottom-left'
              inset={{
                mobile: { horizontal: 18.121, vertical: 16 },
                laptop: { horizontal: 20, vertical: 21.5 },
              }}
              radius={{ mobile: 25, laptop: 28 }}
            />
          </Box>
          <Stack
            gap={{ mobile: pxToRem(12), laptop: pxToRem(24) }}
            sx={{
              position: 'absolute',
              top: { mobile: pxToRem(4), laptop: pxToRem(20) },
              left: { mobile: '50%', laptop: pxToRem(56) },
              transform: { mobile: 'translateX(-50%)', laptop: 'none' },
              width: { mobile: pxToRem(221), laptop: pxToRem(188) },
              alignItems: { mobile: 'center', laptop: 'flex-start' },
              textAlign: { mobile: 'center', laptop: 'left' },
              color: 'primary.main',
            }}
          >
            <Typography
              component='h2'
              id={venue.headingId}
              variant='h2'
              sx={{
                fontSize: { mobile: pxToRem(24), laptop: pxToRem(32) },
                lineHeight: { mobile: pxToRem(32), laptop: pxToRem(40) },
                margin: 0,
                width: '100%',
              }}
            >
              <Box component='span' sx={{ display: { mobile: 'none', laptop: 'block' } }}>
                {venue.headingLines.map((line, i) => (
                  <Box component='span' key={i} sx={{ display: 'block' }}>
                    {line}
                  </Box>
                ))}
              </Box>
              <Box component='span' sx={{ display: { mobile: 'block', laptop: 'none' } }}>
                {venue.headingLinesMobile.map((line, i) => (
                  <Box component='span' key={i} sx={{ display: 'block' }}>
                    {line}
                  </Box>
                ))}
              </Box>
            </Typography>
            <Typography
              sx={{
                fontFamily: '"Roboto", sans-serif',
                fontWeight: 700,
                fontSize: { mobile: pxToRem(12), laptop: pxToRem(16) },
                lineHeight: { mobile: pxToRem(16), laptop: pxToRem(20) },
                margin: 0,
              }}
            >
              {venue.lead}
            </Typography>
          </Stack>
        </Box>

        <Box
          component='img'
          src={venue.mapImage.mobileSrc}
          alt={venue.mapImage.alt}
          aria-hidden='true'
          sx={{
            display: { mobile: 'block', laptop: 'none' },
            width: pxToRem(140),
            height: pxToRem(285),
            objectFit: 'contain',
          }}
        />

        <Stack
          gap={{ mobile: pxToRem(20), laptop: pxToRem(24) }}
          sx={{
            width: { mobile: pxToRem(300), laptop: pxToRem(447) },
            color: 'primary.main',
            textAlign: { mobile: 'center', laptop: 'left' },
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Roboto", sans-serif',
              fontWeight: 400,
              fontSize: { mobile: pxToRem(16), laptop: pxToRem(20) },
              lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
              margin: 0,
            }}
          >
            {venue.intro}
          </Typography>
          <Typography
            sx={{
              fontFamily: '"Roboto", sans-serif',
              fontWeight: 400,
              fontSize: { mobile: pxToRem(16), laptop: pxToRem(20) },
              lineHeight: { mobile: pxToRem(20), laptop: pxToRem(24) },
              margin: 0,
            }}
          >
            {venue.body.before}
            <Box component='span' sx={{ fontWeight: 700 }}>
              {venue.body.venueName}
            </Box>
            {venue.body.after}
          </Typography>
        </Stack>
      </SectionInner>

      <Box
        component='img'
        src={venue.mapImage.desktopSrc}
        alt={venue.mapImage.alt}
        aria-hidden='true'
        sx={{
          display: { mobile: 'none', laptop: 'block' },
          position: 'absolute',
          left: pxToRem(-12),
          top: pxToRem(43),
          width: pxToRem(364),
          height: pxToRem(743),
          objectFit: 'contain',
          pointerEvents: 'none',
          zIndex: 0,
        }}
      />
    </Box>
  );
}
